/* TANIT Box free gift guard.
 * The builder adds the gift as a $0 one-time line with a `_gift` property. If the cart no longer
 * holds any TANIT Box line (`_rc_bundle` property), the gift is removed; with a box present the gift
 * is kept at exactly quantity 1 (extra gift lines or bumped quantities are reset). Runs on load and after
 * every theme cart update (cart page and drawer both dispatch `cart:updated`). */
(function () {
  var busy = false;
  function hasProp(item, key) {
    return !!(item.properties && item.properties[key]);
  }
  function check() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasBox = cart.items.some(function (i) { return hasProp(i, '_rc_bundle'); });
        var gifts = cart.items.filter(function (i) { return hasProp(i, '_gift'); });
        if (!gifts.length) { busy = false; return; }
        var updates = {};
        var changed = false;
        gifts.forEach(function (g, idx) {
          // No box → no gift. With a box → exactly one gift line, quantity 1.
          var want = hasBox ? (idx === 0 ? 1 : 0) : 0;
          if (g.quantity !== want) { updates[g.key] = want; changed = true; }
        });
        if (!changed) { busy = false; return; }
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (r) { return r.json(); })
          .then(function (updated) {
            busy = false;
            if (window.location.pathname.indexOf('/cart') === 0) {
              window.location.reload();
              return;
            }
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: updated } }));
          });
      })
      .catch(function () { busy = false; });
  }
  document.addEventListener('cart:updated', function () { setTimeout(check, 50); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();
